import { css } from "@emotion/css";
import MuiTabs, { tabsClasses as muiTabsClasses } from "@mui/material/Tabs";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type React from "react";
export interface TabsProps {
    value: string;
    onChange?: (event: React.ChangeEvent<object>, value: string) => void;
    variant: "scrollable" | "fullWidth";
    scrollButtons?: "auto";
    children: React.ReactNode;
}
export function Tabs({ value, onChange, variant, scrollButtons, children }: TabsProps) {
    return (<MuiTabs classes={{ root: tabsRootStyles, indicator: tabsIndicatorStyles, list: tabsListStyles }} value={value} onChange={onChange} variant={variant} scrollButtons={scrollButtons}>
            {children}
        </MuiTabs>);
}
const tabsRootStyles = css({
    [`&.${muiTabsClasses.root}`]: {
        color: themeTokens.color.text.secondary,
        width: "100%",
        padding: 0,
        minHeight: "unset",
    },
});
const tabsIndicatorStyles = css({
    [`&.${muiTabsClasses.indicator}`]: {
        backgroundColor: themeTokens.color.border.selected,
        height: "3px",
    },
});
const tabsListStyles = css({
    [`&.${muiTabsClasses.list}`]: {
        gap: "10px",
    },
});
